// extracted by mini-css-extract-plugin
module.exports = {"left":"MyOrderListDetailsPageContent_left__oGQJz","right":"MyOrderListDetailsPageContent_right__xoGGV","boxDetails":"MyOrderListDetailsPageContent_boxDetails__c22zO"};